import {CartSummaryModel} from '../models/checkout/CartSummary/CartSummary.model';
import {CheckoutSettingsModel} from '../models/checkout/checkoutSettings/CheckoutSettings.model';
import {ILocaleKeys} from '../../locale-keys/LocaleKeys';
import {CouponDiscountModel, DiscountScope} from '../models/checkout/CartSummary/CouponDiscount.model';
import {TaxModel} from '../models/checkout/CartSummary/Tax.model';

export const isPartiallyPaid = (cartSummary: CartSummaryModel) => Boolean(cartSummary.paymentSummary.payLater?.amount);
export const hasFreeTrial = (cartSummary: CartSummaryModel) =>
  Boolean(cartSummary.paymentSummary.payAfterFreeTrial?.amount);

export const getTotal = (cartSummary: CartSummaryModel) =>
  !isPartiallyPaid(cartSummary) && !hasFreeTrial(cartSummary)
    ? cartSummary.paymentSummary.payNow.formattedAmount
    : cartSummary.paymentSummary.totalAfterGiftCards.formattedAmount;

export const getTaxName = ({
  taxName,
  checkoutSettings,
  localeKeys,
  moveCheckoutToViewerContext,
}: {
  taxName?: string;
  checkoutSettings: CheckoutSettingsModel;
  localeKeys: ILocaleKeys;
  moveCheckoutToViewerContext: boolean;
}): string => {
  return moveCheckoutToViewerContext
    ? taxName || localeKeys.checkout.order_summary.totals.tax()
    : taxName || checkoutSettings.taxName || localeKeys.checkout.order_summary.totals.tax();
};

export const formatSignedAmount = ({amount, isRTL}: {amount: string; isRTL: boolean}): string => {
  return isRTL ? /* istanbul ignore next */ `${amount}-` : `-${amount}`;
};

export const isFreeShippingCoupon = (
  coupon: CouponDiscountModel,
  couponAlignmentInCartAndCheckout: boolean
): boolean => {
  return couponAlignmentInCartAndCheckout
    ? coupon.scope === DiscountScope.DELIVERY
    : Boolean(coupon.isFreeShippingCoupon);
};

export const isFullTaxExempt = (tax: TaxModel): boolean => tax.exemptAmount.amount > 0 && tax.amount.amount === 0;

export const isPartialTaxExempt = (tax: TaxModel): boolean => tax.exemptAmount.amount > 0 && tax.amount.amount > 0;

export const getTaxesWithSomeTaxExemption = (taxes: TaxModel[]) =>
  taxes.filter((tax) => isFullTaxExempt(tax) || isPartialTaxExempt(tax));
